import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { SecondCameraModalComponent } from '../..'
import { hideSecondCameraModal } from '../../../actions'

const SecondCameraModal = ({ code, isLoading, isShowing, onHide }) => (
  <SecondCameraModalComponent
    shouldShow={isShowing}
    isLoading={isLoading}
    code={code}
    onHide={onHide}
  />
)

SecondCameraModal.propTypes = {
  code: PropTypes.string,
  isShowing: PropTypes.bool,
  isLoading: PropTypes.bool,
  onHide: PropTypes.func,
}

const mapStateToProps = (state) => ({
  code: state.webinar.secondCameraToken,
  isLoading: state.webinar.isSecondCamLoading,
  isShowing: state.webinar.showSecondCameraModal,
})

const mapDispatchToProps = {
  onHide: hideSecondCameraModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(SecondCameraModal)
